import React from "react";
import { useSiteTheme } from "../context/SiteThemeContext";

/**
 * Site-wide theme switcher — Classic vs Dark Mode Lounge.
 * Updates html.pb-site-theme-* for the whole app (content scope + CSS variables).
 */
export default function SiteThemePicker({
  label = "Look & feel",
  hint = "Classic = original · Lounge = premium glass UI",
  className = "",
  compact = false,
}) {
  const { themeId, themes, setThemeId, activeTheme } = useSiteTheme();

  return (
    <div
      className={`d-flex flex-wrap align-items-center gap-2 ${className}`.trim()}
      role="group"
      aria-label={label}
    >
      {!compact ? (
        <span className="text-secondary small mb-0 fw-semibold text-uppercase" style={{ letterSpacing: "0.06em", fontSize: "0.7rem" }}>
          {label}
        </span>
      ) : null}
      <div
        className="d-flex flex-wrap gap-1 p-1 rounded-pill border border-secondary border-opacity-25 pb-theme-switch-track"
        style={{ minWidth: compact ? 140 : 200 }}
      >
        {themes.map((t) => {
          const active = themeId === t.id;
          return (
            <button
              key={t.id}
              type="button"
              className={`btn btn-sm px-3 py-1 rounded-pill border-0 ${
                active ? "pb-theme-switch-btn--active" : "pb-theme-switch-btn"
              }`}
              aria-pressed={active}
              title={t.description}
              onClick={() => setThemeId(t.id)}
            >
              {t.shortLabel || t.label}
            </button>
          );
        })}
      </div>
      <span
        className={`badge rounded-pill ${themeId === "premium" ? "text-bg-primary" : "text-bg-secondary"}`}
        style={
          themeId === "premium"
            ? { background: "linear-gradient(135deg, #a855f7, #7c3aed)" }
            : undefined
        }
      >
        {themeId === "premium" ? "Lounge on" : "Classic on"}
      </span>
      {hint && !compact ? (
        <span className="text-secondary small mb-0" title={activeTheme?.description}>
          {hint}
        </span>
      ) : null}
    </div>
  );
}
